// React and Material-UI imports
import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "components/Card/Card";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import { useSnackbar } from "notistack";
import { Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import closeImage from "assets/img/Close_Image.png";
// Material-UI hooks and utilities
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// Custom styles and components
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { CardActions } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import Modal from "@material-ui/core/Modal";
import AppLoader from "components/AppLoader/Index";
import LoaderSignUp from "components/AppLoader/LoaderSignUp";
import ListItemText from "@material-ui/core/ListItemText";
// Redux actions and utilities
import IconButton from "@material-ui/core/IconButton";
import {
  getRoutingNumberData,
  emptyMerchantRTNReduxState,
  getAccountNumberData,
  emptyMerchantAccReduxState,
  getEmailList,
  getEmailData,
  emptyEmailListReduxState,
} from "Redux/Actions/merchantInformation";
import CheckIcon from "@material-ui/icons/Check";
import { useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import buttonStyle from "assets/jss/material-dashboard-react/components/buttonStyle";
import Tooltip from "@material-ui/core/Tooltip";
import { getCountryTypeList } from "../../Redux/Actions/ProvideRegistration";
import {
  getMerchantListData,
  getMerchantGroupCode,
  getRtpAch,
  getManagerListDataNames,
  getMerchantGroupCodePortfolios,
} from "../../Redux/Actions/merchantInformation";
import {
  sendInviteApiCall,
  submitApiCall,
  submitBSApiCall,
} from "../../actions/Operations";
import {
  actionPermission,
  permissionCheck,
} from "../../Utils/commonUtils";
import { profileCodePermissionCheck } from "../../Utils/commonUtils";
import { cache } from "../../Redux/Helper/fetch";
import { GET_MERCHANT_LIST } from "../../Uintls/Urls";

const useStyles = makeStyles(styles);
function EditServices(props) {
  // React hooks for state management and lifecycle
  const useButtonStyles = makeStyles(buttonStyle);
  const buttonClasses = useButtonStyles();
  const [validationModal, setValidationModal] = React.useState(false); // State for validation modal visibility
  const [assignGroupsModal, setAssignGroupsModal] = React.useState(false); // State for assign groups modal visibility
  const { enqueueSnackbar } = useSnackbar(); // Snackbar for notifications
  const [errorMessage, setErrorMessage] = React.useState(false); // State for error messages
  const theme = useTheme(); // Theme hook for Material-UI
  const [id, setId] = React.useState(null); // State for storing ID from URL
  const smallDevice = useMediaQuery(theme.breakpoints.down("xs")); // Media query for small devices
  const classes = useStyles(); // Custom styles hook
  const [loading, setLoading] = React.useState(false); // State for loading indicator
  const [loadingDialog, setLoadingDialog] = React.useState(false); // State for loading dialog
  const profileId = localStorage.getItem("profileId"); // Retrieve profile ID from local storage
  const menu = JSON.parse(localStorage.getItem("menu")); // Retrieve menu data from local storage
  const profileCode = menu?.Role_Permission_Data?.Profile_Code; // Retrieve profile code from menu
  const [disabled1, setDisabled1] = React.useState(false); // State for disabling certain inputs
  const [rtpValue, setRTPValue] = React.useState(false); // State for RTP value
  const [achValue, setACHValue] = React.useState(false); // State for ACH value
  const [serviceKeyVisible, setServiceKeyVisible] = React.useState(false); // State for RTP value
  const [balanceCheckProvider, setBalanceCheckProvider] = React.useState(""); // State for balance check provider
  const [isRevealAcn, setIsRevealAcn] = React.useState(false); // State for revealing account number
  const [isRevealAcnConfirm, setIsRevealAcnConfirm] = React.useState(false); // State for revealing confirm account number
  const [confirmAccountNumberVisible, setConfirmAccountNumberVisible] =
    React.useState(false); // State for confirm account number visibility
  const [confirmRoutingNumberVisible, setConfirmRoutingNumberVisible] =
    React.useState(false); // State for confirm routing number visibility
  const [submitDisabled, setSubmitDisabled] = React.useState(true); // State for disabling submit button
  const dispatch = useDispatch(); // Redux dispatch hook
  const [removedManagerRTP, setRemovedManagerRTP] = React.useState([]);
  const [removedManagerACH, setRemovedManagerACH] = React.useState([]);
  const [merchantSetup, setMerchantSetup] = React.useState(false);
  const [selectedEmail, setSelectedEmail] = React.useState();
  const [managerId, setManagerId] = React.useState();
  const [updateConfirmDialog, setUpdateConfirmDialog] = React.useState(false);
  const [confirmDialog, setConfirmDialog] = React.useState({
    open: false,
    serviceCode: null,
    onConfirm: null,
  });
  const [touchedServices, setTouchedServices] = React.useState({});
  const [isAllSelected, setIsAllSelected] = React.useState(false); // State for "select all" checkbox
  const [selectedRows, setSelectedRows] = React.useState([]); // State for selected rows in a table
  const [accountAccessibility, setAccountAccessibility] = React.useState([]); // State for account accessibility
  const [originalServices, setOriginalServices] = React.useState([]);
  const originalGroupsRef = useRef([]);
  const [updateConfirmationMessage, setUpdateConfirmationMessage] = React.useState(
    ""
  );
  const [primaryManagerServices, setPrimaryManagerServices] = React.useState([]);
  const tableData = merchantSetup !== "true" ? props.mainData?.merchantInformation?.merchantGroupCodeListPortfolios?.data : props.marchantGroupCodeList?.data; // Retrieve table data from props
  // State for form values
  const [values, handleInput] = React.useState({
    Requested_for_id: "",
    UpdateMg_id: "",
    Requested_by_id: "",
    Invite_Mail_Status: false,
    routingNumber: "",
    accountNumber: "",
    confirmAccountNumber: "",
    confirmRoutingNumber: "",
    bankDetailsCannotBeEdited: false,
    AddressDetailsChecked: true,
    feeTypeSurcharge: true,
    feeRate: "",
    serviceKey: "",
    perTransactionFee: "",
    percentageFee: "",
    aboveTransactionValue: "",
    none: "",
    feeCanNotBeEdited: false,
    Manager_id: "",
    userId: "",
    Status_Code: "",
    Balance_Check_Provider: "",
    mgStatusObjId: "",
    managerListRTP: "",
    managerListACH: "",
  });
  // State for validation errors
  const [validationError, setVlidationError] = React.useState({
    Invite_Mail_Status: false,
    routingNumber: false,
    accountNumber: false,
    confirmAccountNumber: false,
    confirmRoutingNumber: false,
    feeRate: false,
    serviceKey: false,
    balanceCheckProvider: false,
    perTransactionFee: false,
    percentageFee: false,
    aboveTransactionValue: false,
    none: false,
    Manager_id: false,
    userId: false,
    Status_Code: false,
    managerListRTP: false,
    managerListACH: false,
  });
  const checkValidation = (saveDraft = false) => {
    let validate = true;
    const error = {
      Invite_Mail_Status: false,
      routingNumber: false,
      accountNumber: false,
      confirmAccountNumber: false,
      confirmRoutingNumber: false,
      feeRate: false,
      serviceKey: false,
      balanceCheckProvider: false,
      perTransactionFee: false,
      percentageFee: false,
      aboveTransactionValue: false,
      none: false,
      Manager_id: false,
      userId: false,
      Status_Code: false,
      managerListRTP: false,
      managerListACH: false,
    };

    const RTP_FIELDS = [
      "routingNumber",
      "accountNumber",
      "feeRate",
    ];
    const shouldValidateRtp = rtpValue === true;
    const shouldValidateAch = achValue === true;

    for (const key in values) {
      if (shouldValidateRtp) {
        if (
          RTP_FIELDS.includes(key) &&
          (
            values[key] === "" ||
            values[key] === null ||
            values[key] === undefined
          )
        ) {
          error[key] = true;
          validate = false;
        }
      }

      if (shouldValidateAch) {
        if (
          merchantSetup === "true" &&
          (
            !values.Balance_Check_Provider ||
            values.Balance_Check_Provider.length === 0
          )
        ) {
          error.balanceCheckProvider = true;
          validate = false;
        }

        if (
          merchantSetup === "true" &&
          values.Balance_Check_Provider?.includes("DecisionLogic Service") &&
          (
            !values.serviceKey ||
            values.serviceKey === ""
          )
        ) {
          error.serviceKey = true;
          validate = false;
        }
      }

      if (!shouldValidateRtp && !shouldValidateAch) {
        const requiredFields = [
          "businessName",
          "firstName",
          "lastName",
          "email",
        ];

        if (
          requiredFields.includes(key) &&
          (
            values[key] === "" ||
            values[key] === null ||
            values[key] === undefined
          )
        ) {
          error[key] = true;
          validate = false;
        }
      }
      if (key === "routingNumber") {
        if (confirmRoutingNumberVisible) {
          if (
            values[key] !== "" &&
            values[key] !== null &&
            (values[key] !== values.confirmRoutingNumber ||
              values[key]?.length !== 9 ||
              !props.routingNumberData?.available ||
              values.confirmRoutingNumber === "" ||
              values.confirmRoutingNumber === null)
          ) {
            error[key] = true;
            error.confirmRoutingNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          values[key]?.length !== 9
        ) {
          error[key] = true;
          validate = false;
        }
      }
      if (key === "accountNumber") {
        if (confirmAccountNumberVisible) {
          if (
            (values[key] !== "" &&
              values[key] !== null &&
              (values[key] !== values.confirmAccountNumber ||
                values[key]?.length < 8 ||
                values[key]?.length > 17 ||
                !props.accountNumberData.status)) ||
            values.confirmAccountNumber === "" ||
            values.confirmAccountNumber === null
          ) {
            error[key] = true;
            error.confirmAccountNumber = true;
            validate = false;
          }
        } else if (
          values[key] !== "" &&
          values[key] !== null &&
          (values[key]?.length < 8 || values[key]?.length > 17)
        ) {
          error[key] = true;
          validate = false;
        }
      }
      if (key === "feeRate") {
        if (values.feeRate === "Per Transaction" && !values.perTransactionFee) {
          error.perTransactionFee = true;
          validate = false;
        }
        if (values.feeRate === "Percentage" && !values.percentageFee) {
          error.percentageFee = true;
          validate = false;
        }
        if (
          values.feeRate === "Per transaction + Percentage" &&
          (!values.perTransactionFee ||
            !values.percentageFee ||
            !values.aboveTransactionValue)
        ) {
          error.perTransactionFee = !values.perTransactionFee;
          error.percentageFee = !values.percentageFee;
          error.aboveTransactionValue = !values.aboveTransactionValue;
          validate = false;
        }
      }
    }
    setVlidationError(error);
    if (!saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    if (saveDraft) {
      if (!validate) {
        setValidationModal(true);
      }
    }
    return validate;
  };

  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setIsAllSelected(checked);

    if (checked) {
      const updatedSelection = Array.isArray(tableData)
        ? tableData.map((row) => ({
          ...row,
          merchantCodeID: row.id,
          sendTransaction: true,
          transactionQuery: true,
        }))
        : [];
      setSelectedRows(updatedSelection);
    } else {
      // Deselect all rows
      setSelectedRows([]);
    }
    setSubmitDisabled(false);
  };

  const handleCheckboxChange = (row) => {
    setSelectedRows((prevSelected) => {
      const isDuplicate = prevSelected.some((item) => item.id === row.id);
      let updatedSelection;

      if (isDuplicate) {
        // Remove the selected row
        updatedSelection = prevSelected.filter((item) => item.id !== row.id);
      } else {
        // Add the new selection
        updatedSelection = [
          ...prevSelected,
          {
            ...row,
            merchantCodeID: row.id,
            sendTransaction:
              row.sendTransaction !== undefined
                ? row.sendTransaction
                : true,
            transactionQuery:
              row.transactionQuery !== undefined
                ? row.transactionQuery
                : true,
          },
        ];
      }

      // Check if all rows are selected and update `setIsAllSelected`
      setIsAllSelected(updatedSelection.length === tableData.length);
      setSubmitDisabled(false);
      return updatedSelection;
    });
  };
  React.useEffect(() => {
    if (tableData) {
      setLoadingDialog(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  // GLOBAL DISABLE FLAG FOR ENTIRE PAGE
  const isPageDisabled = React.useMemo(() => {
    if (merchantSetup == "false") {
      return true;
    }
    return false;
  }, [merchantSetup]);

  const getServiceStatus = (serviceCode) => accountAccessibility.find(
    s => s.Service_Code === serviceCode
  )?.Status;
  const shouldShowService = (serviceCode) => {
    // Merchant Setup
    // Always show every service from Payment Services API.
    if (merchantSetup === "true") {
      return true;
    }

    // Secondary Manager
    const primaryService = primaryManagerServices.find(
      s => s.Service_Code === serviceCode
    );

    if (!primaryService) {
      return false;
    }

    const status = primaryService.Status;

    return Boolean(status) && status !== "Inactive";
  };
  const isIndeterminateService = (serviceCode) => {
    // User already clicked this checkbox.
    // Never show "-" again.
    if (touchedServices[serviceCode]) {
      return false;
    }

    const service = accountAccessibility.find(
      (item) => item.Service_Code === serviceCode
    );

    if (!service) {
      return false;
    }

    return (
      service.Check === false &&
      service.Status !== "Active" &&
      service.Status !== "Inactive"
    );
  };

  const isServiceChecked = (serviceCode) => {
    const service = accountAccessibility.find(
      item => item.Service_Code === serviceCode
    );

    return service?.Check === true;
  };

  const serviceExists = (serviceCode) => {
    if (merchantSetup === "true") {
      return true;
    }

    return primaryManagerServices.some(
      item => item.Service_Code === serviceCode
    );
  };
  // Remove a chip
  const handleDeleteChip = (rowToDelete) => {
    setSelectedRows((prevSelected) =>
      prevSelected.filter((row) => row !== rowToDelete));
  };

  const handleBatchInsertForRemovedGroups = () => {
    // TODO: backend contract pending for batch insert for removed groups
  };

  const getUpdateConfirmationMessage = () => {
    if (merchantSetup !== "true") {
      return "";
    }

    const normalizeGroupIds = (groups = []) =>
      (Array.isArray(groups) ? groups : [])
        .map((group) => group?.merchantCodeID ?? group?.id ?? group?.Group_Code ?? group?.code ?? group?.value)
        .filter(Boolean);

    const originalGroupIds = new Set(normalizeGroupIds(originalGroupsRef.current));
    const currentGroupIds = new Set(normalizeGroupIds(selectedRows));

    const hasOriginalGroups = originalGroupIds.size > 0;
    const hasCurrentGroups = currentGroupIds.size > 0;

    if (!hasOriginalGroups && !hasCurrentGroups) {
      return "";
    }

    if (!hasOriginalGroups && hasCurrentGroups) {
      return "Note: Please add NACHA Configuration Details for all merchants in the group(s).";
    }

    const hasAdditions = [...currentGroupIds].some((id) => !originalGroupIds.has(id));
    const hasRemovals = [...originalGroupIds].some((id) => !currentGroupIds.has(id));

    if (hasRemovals && !hasAdditions) {
      return "Note: NACHA Configuration Details will be removed for all merchants in the removed group(s).";
    }

    if (hasAdditions || hasRemovals) {
      return "Note: Please update NACHA Configuration Details for all merchants in the group(s).";
    }

    return "";
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    const merchantSetup = queryParams.get("MerchantSetup");
    const Manager_id = queryParams.get("Manager_id");
    setId(idFromUrl);
    setMerchantSetup(merchantSetup);

    setManagerId(Manager_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantSetup]);

  React.useEffect(() => {
    if (props?.merchantListData?.emailData) {
      const {
        City,
        Country,
        First_Name,
        Floor,
        Last_Name,
        Phone_Number,
        PostalCode,
        Room,
        State,
        Street,
      } = props?.merchantListData?.emailData;
      handleInput((prevValues) => ({
        ...prevValues,
        managerRoom: Room,
        managerFloor: Floor,
        managerStreet: Street,
        managerCountry: Country,
        managerState: State,
        managerCity: City,
        managerPostalCode: PostalCode,
        firstName: First_Name,
        lastName: Last_Name,
        phoneNumber: Phone_Number,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailData]);

  React.useEffect(() => {
    if (id) {
      const payload = {
        _id: id,
        _edit_manager_Id: managerId,
      };

      const businesspayload = {
        Existing_Business_id: id,
        _edit_manager_Id: managerId,
      };

      const createCacheKey = (params) => {
        const filteredParams = Object.fromEntries(
          Object.entries(params).filter(
            ([, value]) => value !== undefined && value !== null && value !== ""
          )
        );
        return JSON.stringify(filteredParams);
      };

      const cacheKey = createCacheKey({
        url: GET_MERCHANT_LIST,
        body: payload,
      });

      // Delete only specific cache
      cache.delete(cacheKey);

      // Now API will call fresh
      if (merchantSetup == "true") {
        props.getMerchantListData(payload);
      } else {
        props.getManagerListDataNames(businesspayload);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  React.useEffect(() => {
    props.getRtpAch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClose = () => {
    setAssignGroupsModal(false);
  };
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const idFromUrl = queryParams.get("id");
    if (idFromUrl == null) {
      handleCheckboxChangeRtpAch(true, "VIKExclude");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const data =
      props.merchantListData.merchantListData &&
      props.merchantListData.merchantListData.data;
    if (data && merchantSetup == "true") {
      const balance_Check_Provider =
        data[0]?.Balance_Check_Provider || null;
      setBalanceCheckProvider(balance_Check_Provider);
      const groupVisibility = data[0]?.Manager_Details?.Group_Visibility[0]?.groupCodes || [];
      setSelectedRows(groupVisibility);
      originalGroupsRef.current = Array.isArray(groupVisibility)
        ? groupVisibility.map((group) => ({ ...group }))
        : [];
      if (!Array.isArray(data) || data.length === 0) return;

      const rawStatus =
        data[0]?.ManagerStatus?.Status;

      const statusList = Array.isArray(rawStatus)
        ? rawStatus
        : [];
      const services = statusList.map((item) => ({
        Service_Code: item.Service_Code,
        Status: item.Status,
        Check: item.Status === "Active",
      }));

      setAccountAccessibility(services);
      setOriginalServices(services);
      setTouchedServices({});
      setRTPValue(
        services.some(
          (s) =>
            s.Service_Code === "RTP" &&
            s.Status !== "Inactive"
        )
      );

      setACHValue(
        services.some(
          (s) =>
            s.Service_Code === "ACH" &&
            s.Status !== "Inactive"
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.merchantListData && props?.merchantListData?.merchantListData?.data]);

  useEffect(() => {
    const data =
      props.merchantListData.managerListNames &&
      props.merchantListData.managerListNames.data;
    if (data && merchantSetup !== "true") {
      const balance_Check_Provider =
        data[0]?.Business_Details?.Balance_Check_Provider || null;
      setBalanceCheckProvider(balance_Check_Provider);
      handleInput({
        ...values,
        Status_Code: data[0]?.Status_Code || "",
      });
      // Extract Group_Visibility array and set it to selectedRows
      const groupVisibility = data[0]?.User_Merchant_AcctLinks_Details || [];
      setSelectedRows(groupVisibility);
      originalGroupsRef.current = Array.isArray(groupVisibility)
        ? groupVisibility.map((group) => ({ ...group }))
        : [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.managerListNames && props?.merchantListData?.managerListNames?.data]);
  const handleSendTransactionChange = (row) => {
    setSelectedRows((prevSelected) =>
      prevSelected.map((item) =>
        item.id === row.id
          ? { ...item, sendTransaction: !item.sendTransaction }
          : item));
  };

  const handleTransactionQueryChange = (row) => {
    setSelectedRows((prevSelected) =>
      prevSelected.map((item) =>
        item.id === row.id
          ? {
            ...item,
            transactionQuery: !item.transactionQuery
          }
          : item));
  };

  const handleCheckboxChangeRtpAch = (event, Service_Code) => {
    const isChecked = event === true ? true : event?.target?.checked;
    // SHOW dialog when UNCHECKING
    if (!isChecked) {
      setConfirmDialog({
        open: true,
        serviceCode: Service_Code,
        onConfirm: () => {
          applyServiceChange(Service_Code, isChecked);
          setConfirmDialog({
            open: false,
            serviceCode: null,
            onConfirm: null,
          });
        },
      });
      return;
    }
    applyServiceChange(Service_Code, isChecked);
  };

  const applyServiceChange = (Service_Code, isChecked) => {
    if (Service_Code === "RTP") {
      setRTPValue(isChecked);

      // CLEAR RTP VALIDATIONS WHEN UNCHECKED
      if (!isChecked) {
        setVlidationError((prev) => ({
          ...prev,
          routingNumber: false,
          accountNumber: false,
          confirmAccountNumber: false,
          confirmRoutingNumber: false,
          feeRate: false,
          perTransactionFee: false,
          percentageFee: false,
          aboveTransactionValue: false,
          serviceKey: false,
        }));
      }
    }

    if (Service_Code === "VIKExclude") {
      setSubmitDisabled(!isChecked);
    }
    if (Service_Code === "ACH") {
      setACHValue(isChecked);
      setIsAllSelected(false);

      if (!isChecked) {
        setVlidationError((prev) => ({
          ...prev,
          balanceCheckProvider: false,
          serviceKey: false,
        }));
      }
    }
    setTouchedServices((prev) => ({
      ...prev,
      [Service_Code]: true,
    }));
    setAccountAccessibility(prev => {
      const exists = prev.some(
        s => s.Service_Code === Service_Code
      );

      if (!exists) {
        return [
          ...prev,
          {
            Service_Code,
            Status: "Invited",
            Check: isChecked,
          },
        ];
      }

      return prev.map(item =>
        item.Service_Code === Service_Code
          ? {
            ...item,
            Check: isChecked,
          }
          : item);
    });

    setSubmitDisabled(false);
  };

  const handleConfirmRemove = () => {
    if (confirmDialog.serviceCode) {
      applyServiceChange(confirmDialog.serviceCode, false);
    }
    setConfirmDialog({
      open: false,
      serviceCode: null,
      onConfirm: null,
    });
  };

  const handleCancelRemove = () => {
    setConfirmDialog({
      open: false,
      serviceCode: null,
      onConfirm: null,
    });
  };

  useEffect(() => {
    if (props?.merchantListData?.emailListData?.data && values.email) {
      const emailExists = props.merchantListData.emailListData.data.includes(
        values.email
      );
      if (emailExists) {
        dispatch(getEmailData(values.email));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.emailListData?.data, values.email]);

  React.useEffect(() => {
    if (
      values.confirmAccountNumber !== "" &&
      values.accountNumber !== values.confirmAccountNumber
    ) {
      const error = { ...validationError, confirmAccountNumber: true };
      setVlidationError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    const data = props?.merchantListData?.managerListNames?.data;

    if (!Array.isArray(data) || data.length === 0) return;

    // ===========================
    // PRIMARY MANAGER
    // Used ONLY for SHOW/HIDE
    // ===========================

    const primaryStatus =
      data[0]?.primaryManagerDetails?.Status || [];

    const primaryServices = primaryStatus.map((item) => ({
      Service_Code: item.Service_Code,
      Status: item.Status,
    }));

    setPrimaryManagerServices(primaryServices);

    // ===========================
    // CURRENT MANAGER
    // Used ONLY for CHECK STATE
    // ===========================

    const managerStatus =
      data[0]?.ManagerStatus?.Status || [];

    const accountServices = managerStatus.map((item) => ({
      Service_Code: item.Service_Code,
      Status: item.Status,
      Check: item.Status === "Active",
    }));

    setAccountAccessibility(accountServices);
    setOriginalServices(accountServices);

    const selectedEmail =
      data[0]?.primaryManagerDetails?.primaryManagerInfo?.Email;

    setSelectedEmail(selectedEmail);

    setRTPValue(
      accountServices.some(
        (s) =>
          s.Service_Code === "RTP" &&
          s.Status !== "Inactive"
      )
    );

    setACHValue(
      accountServices.some(
        (s) =>
          s.Service_Code === "ACH" &&
          s.Status !== "Inactive"
      )
    );
  }, [props?.merchantListData?.managerListNames?.data]);

  React.useEffect(() => {
    if (
      values.confirmRoutingNumber !== "" &&
      values.routingNumber !== values.confirmRoutingNumber
    ) {
      const error = { ...validationError, confirmRoutingNumber: true };
      setVlidationError(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  React.useEffect(() => {
    if (!props.formData.countryTypeList) {
      props.getCountryTypeList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const result =
      props.merchantListData.merchantListData &&
      props.merchantListData.merchantListData.data.map((items) => ({
        uid: items?.uid,
        Account_id: items?.Account_id,
        AddressDetailsChecked: items?.AddressDetailsChecked,
        _id: items?._id,
        Created_By: items?.Created_By,
        Manager_id: items?.Manager_id,
        Invite_Date: items?.Invite_Date,
        Created_date: items?.Created_date,
        Updated_date: items?.Updated_date,
        Account_Number: items?.Banking_Details?.Account_Number,
        Routing_Number: items?.Banking_Details?.Routing_Number,
        Bank_Details_Cannot_Be_Edited:
          items?.Banking_Details?.bankDetailsCannotBeEdited,
        FeeType_Name: items?.FeeType?.FeeTypeName,
        FeeType_Discounted: items?.FeeType?.feeTypeDiscounted,
        FeeType_Surcharge: items?.FeeType?.feeTypeSurcharge,
        FeeType_perTransactionFee: items?.FeeType?.perTransactionFee,
        FeeType_percentageFee: items?.FeeType?.percentageFee,
        FeeType_aboveTransactionValue: items?.FeeType?.aboveTransactionValue,
        Fee_can_not_be_edited: items?.FeeType?.feeCanNotBeEdited,
        Requested_by_id: items?.Manager_Details?._id,
        UpdateMg_id: items?.Manager_Details?._id,
        Requested_for_id: items?._id,
        serviceKey: items?.Service_Key,
        Balance_Check_Provider: Array.isArray(items?.Balance_Check_Provider) ? items.Balance_Check_Provider.filter(x => x !== null) : [],
        mgStatusObjId: items?.ManagerStatus?._id,
      }));
    const newResult = result && result[0];
    if (newResult) {
      handleInput({
        ...values,
        Requested_by_id: newResult?.Requested_by_id,
        UpdateMg_id: newResult?.UpdateMg_id,
        Requested_for_id: newResult?.Requested_for_id,
        uid: newResult?.uid,
        Account_id: newResult?.Account_id,
        AddressDetailsChecked: newResult?.AddressDetailsChecked,

        routingNumber: newResult?.Routing_Number,
        accountNumber: newResult?.Account_Number,
        feeRate: newResult?.FeeType_Name,
        serviceKey: newResult?.serviceKey,
        perTransactionFee: newResult?.FeeType_perTransactionFee,
        percentageFee: newResult?.FeeType_percentageFee,
        aboveTransactionValue: newResult?.FeeType_aboveTransactionValue,
        feeCanNotBeEdited: newResult?.Fee_can_not_be_edited,
        bankDetailsCannotBeEdited: newResult?.Bank_Details_Cannot_Be_Edited,
        Status_Code: newResult?.Status_Code,
        Business_id: newResult?._id,
        Balance_Check_Provider: newResult.Balance_Check_Provider,
        mgStatusObjId: newResult?.mgStatusObjId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.merchantListData]);

  React.useEffect(() => {
    if (merchantSetup == "true") return;
    const apiData = props?.merchantListData?.managerListNames?.data;

    if (!Array.isArray(apiData) || apiData.length === 0) return;

    const data = apiData[0];

    if (!data) return;

    const {
      Status_Code,
      managerListACH = [],
      managerListRTP = [],
      ManagerStatus = {},
      Business_Details = {},
      primaryManagerDetails,
    } = data;

    const {
      _id: businessId,
      uid,
      AddressDetailsChecked = true,
      Banking_Details = {},
      FeeType = {},
      Balance_Check_Provider = [],
      Service_Key,
    } = Business_Details;

    const {
      Routing_Number: routingNumber = "",
      Account_Number: accountNumber = "",
      bankDetailsCannotBeEdited = false,
    } = Banking_Details;

    const {
      FeeTypeName = "",
      feeTypeDiscounted = false,
      feeTypeSurcharge = true,
      perTransactionFee = "",
      percentageFee = "",
      aboveTransactionValue = "",
      feeCanNotBeEdited = false,
    } = FeeType;

    handleInput((prev) => ({
      ...prev,

      managerListACH,
      managerListRTP,

      Requested_by_id: primaryManagerDetails?.primaryManagerInfo?._id || "",
      UpdateMg_id: ManagerStatus?._id || "",
      Requested_for_id: businessId || "",

      uid: uid || "",

      AddressDetailsChecked,

      routingNumber,
      accountNumber,

      feeRate: FeeTypeName,
      feeTypeDiscounted,
      feeTypeSurcharge,
      perTransactionFee,
      percentageFee,
      aboveTransactionValue,
      feeCanNotBeEdited,

      bankDetailsCannotBeEdited,

      Status_Code: Status_Code || "",

      Business_id: businessId || "",

      serviceKey: Service_Key || "",

      Balance_Check_Provider: Array.isArray(Balance_Check_Provider)
        ? Balance_Check_Provider.filter((x) => x !== null)
        : [],

      mgStatusObjId: ManagerStatus?._id || "",
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.merchantListData?.managerListNames]);
  React.useEffect(() => {
    // Clear deleted chip list on data reload
    setRemovedManagerRTP([]);
    setRemovedManagerACH([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  React.useEffect(() => {
    if (values.accountNumber === "" || values.routingNumber === "") {
      setDisabled1(true);
      handleInput((prevState) => ({
        ...prevState,
        bankDetailsCannotBeEdited: false,
      }));
    } else {
      setDisabled1(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.accountNumber, values.routingNumber]);

  useEffect(() => {
    props.emptyMerchantAccReduxState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(
    () => () => {
      dispatch(emptyEmailListReduxState());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch]
  );

  React.useEffect(() => {
    if (balanceCheckProvider) {
      handleInput({
        ...values,
        Balance_Check_Provider: balanceCheckProvider,
      });
      if (balanceCheckProvider.includes("DecisionLogic Service")) {
        setServiceKeyVisible(true);
      } else {
        setServiceKeyVisible(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceCheckProvider]);

  React.useEffect(() => {
    const updatedError = { ...validationError };
    if (values.firstName) {
      onChange(values.firstName, "firstName");

      if (/^\d/.test(values.firstName)) {
        updatedError.firstName = true;
      } else {
        updatedError.firstName = false;
      }
    }
    if (values.lastName) {
      onChange(values.lastName, "lastName");

      if (/^\d/.test(values.lastName)) {
        updatedError.lastName = true;
      } else {
        updatedError.lastName = false;
      }
    }
    setVlidationError(updatedError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.firstName, values.lastName]);

  const handleClose = () => {
    setValidationModal(false);
  };

  const handleFormSubmit = (value) => {
    // setSaveDraftClick(true);
    const updatedAccountAccessibility = accountAccessibility.map(service => {
      const existed = originalServices.find(
        x => x.Service_Code === service.Service_Code
      );
      const shouldAddUserEditService =
        (existed?.Check !== undefined && existed.Check !== service.Check) ||
        (existed === undefined && service.Check === true);

      // Rule 1
      if (service.Check) {
        const updatedService = {
          ...service,
          Check: true,
          Status: existed
            ? existed.Status
            : "Invited",
        };

        return shouldAddUserEditService
          ? { ...updatedService, userEditService: true }
          : updatedService;
      }

      // Rule 2
      if (
        service.Status &&
        service.Status !== "Inactive" &&
        service.Status !== "Active"
      ) {
        const updatedService = {
          ...service,
          Check: false,
          Status: service.Status,
        };

        return shouldAddUserEditService
          ? { ...updatedService, userEditService: true }
          : updatedService;
      }

      // Rule 3
      const updatedService = {
        ...service,
        Check: false,
        Status: "Inactive",
      };

      return shouldAddUserEditService
        ? { ...updatedService, userEditService: true }
        : updatedService;
    });

    // Ensure both services exist, adding them if missing
    handleClose();
    setValidationModal(false);
    if (value === "update") {
      if (checkValidation(true)) {
        setLoading(true);
        setValidationModal(false);
        const payload = {
          ...values,
          Module_Name: "Merchant Submit Page",
          Module_Code: 2,
          Status_Code: 1,
          Resend_Invite: null,
          Business_OBJid: values.Business_id,
          Manager_OBJid: values.UpdateMg_id,
          Manager_id: managerId || profileId,
          mgStatusObjId: values.mgStatusObjId,
          accountAccessibility: updatedAccountAccessibility,
          Group_Visibility: selectedRows,
          balanceCheckProvider,
          removedManagerRTP,
          removedManagerACH,
        };
        const newPyalod = {
          ...values,
          Module_Name: "Manager Submit Page",
          Module_Code: 2,
          Status_Code: 1,
          Resend_Invite: null,
          Business_OBJid: values.Business_id,
          Manager_OBJid: values.UpdateMg_id,
          Manager_id: profileId,
          mgStatusObjId: values.mgStatusObjId,
          accountAccessibility: updatedAccountAccessibility,
          groupCodes: selectedRows,
          balanceCheckProvider,
          removedManagerRTP,
          removedManagerACH,
          Secondary_Manager_Action: merchantSetup !== "true",
          Requested_by_id: managerId,
        };

        let finalPayload = merchantSetup !== "true" ? newPyalod : payload;

        if (merchantSetup !== "true") {
          finalPayload = {
            ...finalPayload,
            accountAccessibility: finalPayload.accountAccessibility
              .map((service) => {
                if (service.Status === "Inactive" && service.Check === false) return { ...service, Status: "Inactive", Check: false };
                if (service.Status === "Inactive" && service.Check === true) return { ...service, Status: "Invited" };
                return service;
              })
              .filter(Boolean),
          };
        }

        const normalizeAccountAccessibility = (services = []) =>
          (Array.isArray(services) ? services : [])
            .map((service) => `${service.Service_Code}|${service.Status}`);

        const originalAccessibility = new Set(normalizeAccountAccessibility(originalServices));
        const currentAccessibility = normalizeAccountAccessibility(finalPayload.accountAccessibility);
        const accountAccessibilityChanged =
          originalAccessibility.size !== currentAccessibility.length ||
          currentAccessibility.some((key) => !originalAccessibility.has(key));

        if (accountAccessibilityChanged) {
          finalPayload = {
            ...finalPayload,
            userAccountEdit: true,
          };
        }

        const normalizeGroupIds = (groups = []) =>
          (Array.isArray(groups) ? groups : [])
            .map((group) => group?.merchantCodeID ?? group?.id ?? group?.Group_Code ?? group?.code ?? group?.value)
            .filter(Boolean);

        const originalGroupIds = new Set(normalizeGroupIds(originalGroupsRef.current));
        const currentGroupIds = new Set(normalizeGroupIds(selectedRows));

        const hasAdditions = [...currentGroupIds].some((id) => !originalGroupIds.has(id));
        const hasRemovals = [...originalGroupIds].some((id) => !currentGroupIds.has(id));

        if (hasAdditions || hasRemovals) {
          finalPayload = {
            ...finalPayload,
            userGroupEdit: true,
          };
        }
        props.submitApiCall(
          finalPayload,
          (res) => {
            setLoading(false);
            if (res.status === true) {
              enqueueSnackbar(`${res.message}`, {
                variant: "success",
              });
              if (merchantSetup == "true") {
                props.history.push(`/${props.mainData.app.layout}/Merchant`);
              } else {
                props.history.push(`/${props.mainData.app.layout}/ManagerList`);
              }
            }
          },
          (err) => {
            setLoading(false);
            enqueueSnackbar(`${err.message}`, {
              variant: "error",
            });
            if (merchantSetup == "true") {
              props.history.push(`/${props.mainData.app.layout}/Merchant`);
            } else {
              props.history.push(`/${props.mainData.app.layout}/ManagerList`);
            }
          }
        );
      } else {
        setValidationModal(true);
      }
    }
  };

  const handleErrorMessage = () => {
    setLoading(false);
    setValidationModal(false);
    setErrorMessage(false);
    // setSaveDraftClick(false);
  };
  const handleAssignGroup = () => {
    setAssignGroupsModal(true);
    props.getMerchantGroupCode();
  };
  const handleAssignAccounts = (value) => {
    const payload = {
      email: value,
      managerId: values.Requested_by_id,
      businessId: values.Business_id || id,
    };
    props.getMerchantGroupCodePortfolios(payload);
  };

  const onChange = (value, type) => {
    const allState = { ...values };
    const error = { ...validationError };
    error[type] = false;
    allState[type] = value;
    allState.Manager_id = profileId;
    allState.userId = "";

    let accountNumberEdited = false;
    let routingNumberEdited = false;

    if (type === "accountNumber") {
      accountNumberEdited = true;
      if (value.length < 8 || value.length > 17) {
        error[type] = true;
        allState[type] = value;
      }
      if (value.length === 8) {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "confirmAccountNumber") {
      if (value !== values.accountNumber) {
        error[type] = true;
        allState[type] = value;
      }
      if (value === values.accountNumber) {
        error[type] = false;
        allState[type] = value;
      }
    }
    if (type === "confirmRoutingNumber") {
      if (value !== values.routingNumber) {
        error[type] = true;
        allState[type] = value;
      }
      if (value === values.routingNumber) {
        error[type] = false;
        allState[type] = value;
      }
    }

    if (type === "routingNumber") {
      routingNumberEdited = true;
      if (!/^[0-9]{9}$/.test(value)) {
        if (value.length !== 9) {
          error[type] = true;
          allState[type] = value;
        }
        if (value.length === 9) {
          error[type] = false;
          allState[type] = value;
        }
      }
    }
    if (accountNumberEdited) {
      setConfirmAccountNumberVisible(true);
    }
    if (routingNumberEdited) {
      setConfirmRoutingNumberVisible(true);
    }
    if (type === "feeRate") {
      allState.feeRate = value;
      allState.perTransactionFee = "";
      allState.percentageFee = "";
      allState.aboveTransactionValue = "";
      allState.none = "";
    }
    if (type === "feeTypeSurcharge" && value) {
      allState.feeTypeDiscounted = false;
    }
    if (type === "feeTypeDiscounted" && value) {
      allState.feeTypeSurcharge = false;
    }
    handleInput(allState);
    setVlidationError(error);
  };

  const displayAccountNumber = () => {
    const { accountNumber } = values;
    if (!accountNumber) {
      return "";
    }
    if (isRevealAcn || values?.accountNumber?.length <= 4) {
      return values?.accountNumber;
    }
    const maskedNumber =
      "*".repeat(values?.accountNumber?.length - 4) +
      values?.accountNumber?.slice(-4);
    return maskedNumber;
  };

  const displayConfirmAccountNumber = () => {
    if (isRevealAcnConfirm || values?.confirmAccountNumber?.length <= 4) {
      return values?.confirmAccountNumber;
    }
    const maskedNumber =
      "*".repeat(values?.confirmAccountNumber?.length - 4) +
      values?.confirmAccountNumber?.slice(-4);
    return maskedNumber;
  };

  const handleEditFeeCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    handleInput((prevState) => ({
      ...prevState,
      feeCanNotBeEdited: isChecked,
    }));
  };

  const handleBankDetailsCheckboxChange = (event) => {
    if (!disabled1) {
      const isChecked1 = event.target.checked;
      handleInput((prevState) => ({
        ...prevState,
        bankDetailsCannotBeEdited: isChecked1,
      }));
    }
  };

  const clearRoutingNumberData = () => {
    props.emptyMerchantRTNReduxState();
  };

  const clearAccountNumberData = () => {
    props.emptyMerchantAccReduxState();
  };

  const handleBack = () => {
    localStorage.setItem("BackPressed", true);
    if (merchantSetup == "true") {
      props.history.push(`/${props.mainData.app.layout}/Merchant`);
    } else {
      props.history.push(`/${props.mainData.app.layout}/ManagerList`);
    }
  };

  const shouldDisableService = (serviceCode) => {
    if (merchantSetup === "true") {
      return false;
    }

    return !serviceExists(serviceCode);
  };
  return (
    <div style={{ paddingBottom: "40px" }}>
      {/* Loader component to show loading state */}
      <AppLoader loader={!validationModal && loading} />

      {/* Validation Modal */}
      <Modal open={validationModal} onClose={() => setValidationModal(false)}>
        <div className={classes.modalDiv}>
          <Card
            style={{
              width: "50%",
              maxWidth: "40%",
              height: "auto",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                minInlineSize: "-webkit-fill-available",
                textAlign: "start",
                height: "auto",
                maxHeight: "70vh",
                display: "flex",
                overflow: "auto",
                flexWrap: "nowrap",
                marginTop: "10%",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {/* Close image */}
              <img
                src={closeImage}
                style={{ width: "10%", marginBottom: "3%" }}
                alt=""
              />
              <div className={classes.successText}>
                {/* Error message */}
                {!errorMessage ? (
                  <Typography
                    style={{ textAlign: "center" }}
                    color="error"
                    variant="subtitle2"
                    gutterBottom
                  >
                    Please correct all validation errors before proceeding. Note
                    the highlighted fields.
                  </Typography>
                ) : (
                  ""
                )}
              </div>
              {/* Display error messages if any */}
              {errorMessage && (
                <div
                  style={{ marginTop: "2%" }}
                  className={classes.successText}
                >
                  {errorMessage &&
                    errorMessage.map((key) => (
                      <div className={classes.successText}>
                        -{` ${key.msg}`}{" "}
                      </div>
                    ))}
                </div>
              )}
              <br />
            </div>

            {/* Modal actions */}
            <CardActions style={{ margin: "5%" }}>
              <Button
                variant="contained"
                className={classes.buttonStyle}
                color="#696969"
                size="sm"
                onClick={() => handleErrorMessage()}
              >
                Ok
              </Button>
            </CardActions>
          </Card>
        </div>
      </Modal>
      {/* Assign Groups Modal */}
      <Modal open={assignGroupsModal}>
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            height: "100%",
            width: "30%", // Adjust width as needed
            backgroundColor: "white",
            boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          {/* Loader for Assign Groups */}
          <LoaderSignUp loader={loadingDialog} />
          <CardActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Close button */}
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
            <Typography
              style={{
                marginBottom: "10px",
                fontWeight: "600",
                paddingRight: "10px",
              }}
            >
              Selected: {selectedRows?.length} / {tableData?.length}
            </Typography>
          </CardActions>

          {/* Table for Assign Groups */}
          {merchantSetup !== "true" ? (
            <Card
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                margin: "0px",
              }}
            >
              <TableContainer component={Paper} style={{ maxHeight: "90vh" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          indeterminate={
                            selectedRows?.length > 0 &&
                            selectedRows?.length < tableData?.length
                          }
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      <TableCell>
                        <strong>Group Code</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Name</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Code</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Account Type</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Send Transaction</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Transaction Query</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.mainData?.merchantInformation?.merchantGroupCodeListPortfolios?.data &&
                      props.mainData?.merchantInformation?.merchantGroupCodeListPortfolios?.data?.map(
                        (row, index) => {
                          const isRowSelected = (selectedRows ?? []).some(
                            (item) => item.id === row.id
                          );
                          const currentRow =
                            (selectedRows ?? []).find(
                              (item) => item.id === row.id
                            ) || {};

                          return (
                            <TableRow key={index}>
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  checked={isRowSelected}
                                  onChange={() => handleCheckboxChange(row)}
                                />
                              </TableCell>
                              <TableCell>{row.merchantGroupCode}</TableCell>
                              <TableCell>{row.merchantName}</TableCell>
                              <TableCell>{row.merchantCode}</TableCell>
                              <TableCell>{row.accountTypeName}</TableCell>
                              <TableCell>
                                <Checkbox
                                  color="primary"
                                  checked={currentRow.sendTransaction || false}
                                  onChange={() =>
                                    handleSendTransactionChange(row)
                                  }
                                />
                              </TableCell>
                              <TableCell>
                                <Checkbox
                                  color="primary"
                                  checked={currentRow.transactionQuery || false}
                                  onChange={() =>
                                    handleTransactionQueryChange(row)
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          ) : (
            <Card
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                margin: "0px",
              }}
            >
              <TableContainer component={Paper} style={{ maxHeight: "90vh" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        {/* Select All Checkbox */}
                        <Checkbox
                          color="primary"
                          indeterminate={
                            selectedRows?.length > 0 &&
                            selectedRows?.length < tableData?.length
                          }
                          checked={isAllSelected}
                          onChange={(e) => {
                            handleSelectAll(e);
                            setSubmitDisabled(false);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <strong>Name</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Render table rows */}
                    {tableData?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={selectedRows.some(
                              (item) => item.id === row.id
                            )}
                            onChange={() => {
                              setSubmitDisabled(false);
                              handleCheckboxChange(row);
                            }}
                          />
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          )}
        </div>
      </Modal>
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancelRemove}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Confirm Service Removal
        </DialogTitle>

        <DialogContent>
          Are you sure you want to remove{" "}
          <b>{confirmDialog.serviceCode}</b> service from this business?
        </DialogContent>

        <DialogActions>

          <button
            type="button"
            className={buttonClasses.cancelButton}
            onClick={handleCancelRemove}
          >
            Cancel
          </button>

          <button
            type="button"
            className={buttonClasses.button}
            onClick={handleConfirmRemove}
          >
            Confirm
          </button>

        </DialogActions>

      </Dialog>
      <Dialog
        open={updateConfirmDialog}
        onClose={() => setUpdateConfirmDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          Confirm Update
        </DialogTitle>

        <DialogContent>
          <div>Are you sure you want to update services for this business?</div>
          <div className={classes.confirmModalMsg}>
            {updateConfirmationMessage}
          </div>
        </DialogContent>

        <DialogActions>

          <button
            type="button"
            className={buttonClasses.cancelButton}
            onClick={() => setUpdateConfirmDialog(false)}
          >
            Cancel
          </button>

          <button
            type="button"
            className={buttonClasses.button}
            onClick={() => {
              setUpdateConfirmDialog(false);
              handleFormSubmit("update");
            }}
          >
            Confirm
          </button>

        </DialogActions>

      </Dialog>

      <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      <Grid
        container
        style={{ justifyContent: "center", margin: "20px 0" }}
        className={classes.margin}
      >
        <Grid item lg={12} sm={12} xs={12}>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>
              Services Subscribed
            </Typography>
          </Box>
          <Box
            style={{
              textAlign: "center",
              marginTop: "10px",
              justifyContent: "inherit",
              flexWrap: smallDevice ? "wrap" : "nowrap",
            }}
          >
            {props?.achRtpList &&
              props?.achRtpList?.data
                ?.filter((row) => shouldShowService(row.Service_Code))
                .map((row, index) => (
                  <FormControlLabel
                    key={index}
                    control={(
                      <Tooltip
                        title={
                          isIndeterminateService(row.Service_Code)
                            ? `Current Status: ${getServiceStatus(row.Service_Code)}`
                            : ""
                        }
                        disableHoverListener={!isIndeterminateService(row.Service_Code)}
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: "13px",
                              maxWidth: 260,
                              padding: "10px 14px",
                            },
                          },
                        }}
                      >
                        <Checkbox
                          disabled={
                            // isPageDisabled ||
                            shouldDisableService(row.Service_Code)
                          }
                          checked={isServiceChecked(row.Service_Code)}
                          indeterminate={isIndeterminateService(row.Service_Code)}
                          onChange={(event) => {
                            setSubmitDisabled(false);
                            handleCheckboxChangeRtpAch(event, row.Service_Code);
                          }}
                          color="primary"
                        />
                      </Tooltip>
                    )}
                    style={{
                      color: "#454545",
                    }}
                    label={`${row?.ServiceName}`}
                  />
                ))}
          </Box>
        </Grid>
      </Grid>
      {rtpValue && (
        <>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>RTP </Typography>
          </Box>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
              backgroundColor: "#afafaf",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography
              style={{
                color: "black",
              }}
              className={classes.tittleTextColor}
            >
              Banking Details
            </Typography>
          </Box>
          <Box className={classes.marginBox}>
            <Grid container className={classes.margin}>
              <Grid item lg={6} sm={3} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  required={actionPermission(
                    permissionCheck.Category.setup,
                    permissionCheck.Page.merchant,
                    permissionCheck.option.asterisk
                  )}
                  className={classes.quaterInput}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  onPaste={(e) => e.preventDefault()}
                  onCopy={(e) => e.preventDefault()}
                  label="Routing Number"
                  error={validationError.routingNumber}
                  value={values.routingNumber}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    const routingNumber = e.target.value;
                    const confirmRoutingNumber = values.confirmRoutingNumber;
                    if (e.target.value.length === 9) {
                      const data = {
                        routingNumber: e.target.value,
                        Module_Name:
                          profileCode ===
                            profileCodePermissionCheck.profileCode.VCS
                            ? "Invite Page"
                            : "Merchant Submit Page",
                        Module_Code:
                          profileCode ===
                            profileCodePermissionCheck.profileCode.VCS
                            ? 1
                            : 2,
                        Business_uid: values.uid,
                        Business_Name: values.businessName,
                        Requested_for_id: values?.Requested_for_id,
                        Requested_by_id: values?.Requested_by_id,
                        Manager_id: values?.Manager_id,
                        Manager_Name: `${values.firstName}${values.lastName}`,
                      };
                      props.getRoutingNumberData(data);
                    }
                    if (e.target.value.length !== 9) {
                      clearRoutingNumberData();
                    }
                    if (
                      /^[0-9]\d*$/g.test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      onChange(e.target.value, "routingNumber");
                      if (props.accountNumberData?.status === false) {
                        clearAccountNumberData();
                      }
                    }
                    if (
                      values.accountNumber !== "" &&
                      values.confirmAccountNumber !== "" &&
                      values.accountNumber !== null &&
                      values.confirmAccountNumber !== null &&
                      routingNumber === confirmRoutingNumber &&
                      values.accountNumber === values.confirmAccountNumber &&
                      routingNumber.length === 9
                    ) {
                      const data = {
                        routingNumber,
                        accountNumber: values.accountNumber,
                      };
                      props.getAccountNumberData(data);
                    } else if (
                      values.Status_Code === 1 ||
                      values.Status_Code === 4
                    ) {
                      if (
                        values.accountNumber !== "" &&
                        values.accountNumber !== null &&
                        routingNumber === confirmRoutingNumber &&
                        routingNumber.length === 9
                      ) {
                        const data = {
                          routingNumber,
                          accountNumber: values.accountNumber,
                        };
                        props.getAccountNumberData(data);
                      }
                    }
                  }}
                  disabled={isPageDisabled}
                  helperText={
                    validationError.routingNumber &&
                      values?.routingNumber?.length !== 9
                      ? "9 Digit Routing Number is Required."
                      : null
                  }
                  name="routingNumber"
                  id="routingNumber"
                  type="text"
                />
                <Typography style={{ paddingLeft: "38px", color: "#e67452" }}>
                  {props.routingNumberData && props?.routingNumberData?.network}
                  &nbsp;&nbsp;
                  {props.routingNumberData &&
                    props?.routingNumberData?.rdfi_name}
                  {props.routingNumberData &&
                    !props?.routingNumberData?.available &&
                    "This routing number is not supported"}
                </Typography>
              </Grid>
              {confirmRoutingNumberVisible && (
                <Grid item lg={6} sm={3} xs={12}>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={isPageDisabled}
                    required={values.routingNumber !== ""}
                    className={classes.quaterInput}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    label="Confirm Routing Number"
                    error={
                      validationError.confirmRoutingNumber &&
                      (values.confirmRoutingNumber === "" ||
                        values.confirmRoutingNumber !== values.routingNumber)
                    }
                    onChange={(e) => {
                      setSubmitDisabled(false);
                      const confirmRoutingNumber = e.target.value;
                      const routingNumber = values.routingNumber;
                      if (
                        /^[0-9]\d*$/g.test(e.target.value) ||
                        e.target.value === ""
                      ) {
                        onChange(e.target.value, "confirmRoutingNumber");
                        if (props.accountNumberData?.status === false) {
                          clearAccountNumberData();
                        }
                      }
                      if (
                        values.accountNumber !== "" &&
                        values.confirmAccountNumber !== "" &&
                        values.accountNumber !== null &&
                        values.confirmAccountNumber !== null &&
                        routingNumber === confirmRoutingNumber &&
                        values.accountNumber === values.confirmAccountNumber &&
                        confirmRoutingNumber.length === 9
                      ) {
                        const data = {
                          routingNumber: confirmRoutingNumber,
                          accountNumber: values.accountNumber,
                        };
                        props.getAccountNumberData(data);
                      } else if (
                        values.Status_Code === 1 ||
                        values.Status_Code === 4
                      ) {
                        if (
                          values.accountNumber !== "" &&
                          values.accountNumber !== null &&
                          routingNumber === confirmRoutingNumber &&
                          confirmRoutingNumber.length === 9
                        ) {
                          const data = {
                            routingNumber: confirmRoutingNumber,
                            accountNumber: values.accountNumber,
                          };
                          props.getAccountNumberData(data);
                        }
                      }
                    }}
                    helperText={
                      validationError.confirmRoutingNumber &&
                      values.confirmRoutingNumber !== "" &&
                      values.routingNumber !== values.confirmRoutingNumber &&
                      "Routing number does not match"
                    }
                    name="confirmRoutingNumber"
                    id="confirmRoutingNumber"
                    type="text"
                  />
                </Grid>
              )}
            </Grid>

            <Grid container className={classes.margin}>
              <Grid item lg={6} sm={3} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  required={actionPermission(
                    permissionCheck.Category.setup,
                    permissionCheck.Page.merchant,
                    permissionCheck.option.asterisk
                  )}
                  className={classes.quaterInput}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLableColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    inputProps: { min: 0 },
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  onFocus={() => {
                    setIsRevealAcn(true);
                  }}
                  onBlur={() => {
                    setIsRevealAcn(false);
                  }}
                  onClick={() => {
                    setIsRevealAcn(true);
                  }}
                  onPaste={(e) => e.preventDefault()}
                  onCopy={(e) => e.preventDefault()}
                  label="Account Number"
                  error={
                    validationError.accountNumber &&
                    (
                      values.accountNumber === "" ||
                      values.accountNumber.length < 8 ||
                      values.accountNumber.length > 17 ||
                      (
                        values.confirmAccountNumber !== "" &&
                        values.accountNumber !== values.confirmAccountNumber
                      )
                    )
                  }
                  disabled={isPageDisabled}
                  helperText={
                    validationError.accountNumber
                      ? values.accountNumber === ""
                        ? "Account Number is required."
                        : values.accountNumber.length < 8 ||
                          values.accountNumber.length > 17
                          ? "Min 8 to Max 17 Digit Account Number is required."
                          : values.confirmAccountNumber !== "" &&
                            values.accountNumber !== values.confirmAccountNumber
                            ? "Account number does not match."
                            : null
                      : null
                  }
                  value={displayAccountNumber()}
                  onChange={(e) => {
                    setSubmitDisabled(false);
                    const accountNumber = e.target.value;
                    const confirmAccountNumber = values.confirmAccountNumber;
                    if (
                      values.routingNumber !== "" &&
                      values.confirmRoutingNumber !== "" &&
                      confirmAccountNumber !== "" &&
                      values.routingNumber !== null &&
                      values.confirmRoutingNumber !== null &&
                      confirmAccountNumber === accountNumber &&
                      values.routingNumber === values.confirmRoutingNumber &&
                      accountNumber.length >= 8 &&
                      accountNumber.length <= 17
                    ) {
                      const data = {
                        routingNumber: values.routingNumber,
                        accountNumber,
                      };
                      props.getAccountNumberData(data);
                    } else if (
                      values.Status_Code === 1 ||
                      values.Status_Code === 4
                    ) {
                      if (
                        values.routingNumber !== "" &&
                        values.routingNumber !== null &&
                        confirmAccountNumber === accountNumber &&
                        accountNumber.length >= 8 &&
                        accountNumber.length <= 17
                      ) {
                        const data = {
                          routingNumber: values.routingNumber,
                          accountNumber,
                        };
                        props.getAccountNumberData(data);
                      }
                    }
                    if (
                      /^[0-9]*$/g.test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      onChange(e.target.value, "accountNumber");
                      if (props.accountNumberData?.status === false) {
                        clearAccountNumberData();
                      }
                    }
                  }}
                  name="accountNumber"
                  id="accountNumber"
                  type="text"
                />
                {!confirmAccountNumberVisible &&
                  values.Status_Code === 1 &&
                  ((values.routingNumber === values.confirmRoutingNumber ||
                    values.accountNumber === values.confirmAccountNumber) &&
                    props?.accountNumberData?.status ? (
                    <CheckIcon style={{ color: "green" }} />
                  ) : props?.accountNumberData?.status ? (
                    clearAccountNumberData()
                  ) : (
                    ""
                  ))}
              </Grid>
              {confirmAccountNumberVisible && (
                <Grid item lg={6} sm={3} xs={12}>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    required={values.accountNumber !== ""}
                    className={classes.quaterInput}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    onPaste={(e) => e.preventDefault()}
                    onCopy={(e) => e.preventDefault()}
                    label="Confirm Account Number"
                    error={
                      validationError.confirmAccountNumber &&
                      (
                        values.confirmAccountNumber === "" ||
                        values.confirmAccountNumber.length < 8 ||
                        values.confirmAccountNumber.length > 17 ||
                        values.confirmAccountNumber !== values.accountNumber
                      )
                    }
                    onFocus={() => {
                      setIsRevealAcnConfirm(true);
                    }}
                    onBlur={() => {
                      setIsRevealAcnConfirm(false);
                    }}
                    onClick={() => {
                      setIsRevealAcnConfirm(true);
                    }}
                    helperText={
                      validationError.confirmAccountNumber
                        ? values.confirmAccountNumber === ""
                          ? "Confirm Account Number is required."
                          : values.confirmAccountNumber.length < 8 ||
                            values.confirmAccountNumber.length > 17
                            ? "Min 8 to Max 17 Digit Account Number is required."
                            : values.confirmAccountNumber !== values.accountNumber
                              ? "Account number does not match."
                              : null
                        : null
                    }
                    onChange={(e) => {
                      setSubmitDisabled(false);
                      const accountNumber = values.accountNumber;
                      const confirmAccountNumber = e.target.value;

                      if (
                        (/^[0-9]*$/g.test(confirmAccountNumber) ||
                          confirmAccountNumber === "") &&
                        confirmAccountNumber.length <= 17
                      ) {
                        onChange(confirmAccountNumber, "confirmAccountNumber");
                        if (props.accountNumberData?.status === false) {
                          clearAccountNumberData();
                        }
                      }

                      if (
                        values.routingNumber !== "" &&
                        values.confirmRoutingNumber !== "" &&
                        values.routingNumber !== null &&
                        values.confirmRoutingNumber !== null &&
                        accountNumber === confirmAccountNumber &&
                        values.routingNumber === values.confirmRoutingNumber &&
                        confirmAccountNumber.length >= 8 &&
                        confirmAccountNumber.length <= 17
                      ) {
                        const data = {
                          routingNumber: values.routingNumber,
                          accountNumber: confirmAccountNumber,
                        };
                        props.getAccountNumberData(data);
                      } else if (
                        values.Status_Code === 1 ||
                        values.Status_Code === 4
                      ) {
                        if (
                          values.routingNumber !== "" &&
                          values.routingNumber !== null &&
                          accountNumber === confirmAccountNumber &&
                          confirmAccountNumber.length >= 8 &&
                          confirmAccountNumber.length <= 17
                        ) {
                          const data = {
                            routingNumber: values.routingNumber,
                            accountNumber: confirmAccountNumber,
                          };
                          props.getAccountNumberData(data);
                        }
                      }
                    }}
                    disabled={isPageDisabled}
                    value={displayConfirmAccountNumber()}
                    name="confirmAccountNumber"
                    id="confirmAccountNumber"
                    type="text"
                  />
                  {values.Status_Code === 1 || values.Status_Code === 4 ? (
                    (values.routingNumber === values.confirmRoutingNumber ||
                      values.accountNumber === values.confirmAccountNumber) &&
                      props?.accountNumberData?.status ? (
                      <CheckIcon style={{ color: "green" }} />
                    ) : props?.accountNumberData?.status ? (
                      clearAccountNumberData()
                    ) : (
                      ""
                    )
                  ) : values.accountNumber === values.confirmAccountNumber &&
                    values.routingNumber === values.confirmRoutingNumber &&
                    props?.accountNumberData?.status ? (
                    <CheckIcon style={{ color: "green" }} />
                  ) : props?.accountNumberData?.status ? (
                    clearAccountNumberData()
                  ) : (
                    ""
                  )}
                </Grid>
              )}
              {props.accountNumberData?.status === false &&
                props?.accountNumberData.Business_Name == null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  {`"${props?.accountNumberData?.message}"`}
                </Typography>
              ) : (
                ""
              )}
              {profileCode === profileCodePermissionCheck.profileCode.VCS &&
                props.accountNumberData?.status === false &&
                props?.accountNumberData?.Business_Name != null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  {`This Account and Routing Number combination is already linked
              with business "${props?.accountNumberData?.Business_Name}",
              managed by "${props?.accountNumberData?.Manager_Name}"`}
                </Typography>
              ) : (
                ""
              )}
              {profileCode !== profileCodePermissionCheck.profileCode.VCS &&
                props.accountNumberData?.status === false &&
                props?.accountNumberData?.Business_Name != null ? (
                <Typography style={{ paddingLeft: "38px", color: "red" }}>
                  Please enter correct account number and routing number
                </Typography>
              ) : (
                ""
              )}
              {profileCode !==
                (profileCodePermissionCheck.profileCode.SA ||
                  profileCodePermissionCheck.profileCode.ADM) && (
                  <Grid
                    item
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xl: "center",
                        lg: "center",
                        md: "flex-start",
                      },
                      alignItems: "center",
                      alignContent: "center",
                    }}
                    lg={12}
                    sm={6}
                    xs={3}
                  >
                    <FormControl
                      className={classes.root}
                      inputlabelprops={{
                        classes: {
                          root: classes.activeInputLableColor,
                          focused: "focused",
                        },
                      }}
                      component="fieldset"
                    >
                      <FormGroup
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignContent: "center",
                          alignItems: "center",
                          flexWrap: "nowrap",
                        }}
                        row
                      >
                        <FormLabel
                          style={{ marginTop: "10px", fontSize: "14px" }}
                          component="span"
                        >
                          Bank details cannot be edited by business
                        </FormLabel>
                        <FormControlLabel
                          style={{ marginTop: "10px", marginLeft: "10px" }}
                          control={(
                            <Checkbox
                              color="primary"
                              checked={
                                values.bankDetailsCannotBeEdited && !disabled1
                              }
                              disabled={isPageDisabled}
                              onChange={(e) => {
                                setSubmitDisabled(false);
                                handleBankDetailsCheckboxChange(e);
                              }}
                              name="bankDetailsCannotBeEdited"
                            />
                          )}
                        />
                      </FormGroup>
                      <FormHelperText>
                        {validationError.bankDetailsCannotBeEdited}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                )}
            </Grid>
            {values.Account_id && (
              <Grid
                item
                lg={4}
                sm={6}
                xs={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#696969",
                }}
                className={classes.margin}
              >
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <Typography>Account ID :{values.Account_id} </Typography>
              </Grid>
            )}

            <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
          </Box>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
              backgroundColor: "#afafaf",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography
              style={{
                color: "black",
              }}
              className={classes.tittleTextColor}
            >
              Fee Details
            </Typography>
          </Box>

          <Grid container className={classes.margin}>
            <Grid item lg={4} sm={6} xs={12}>
              <TextField
                select
                disabled={isPageDisabled}
                required
                className={classes.root}
                inputlabelprops={{
                  classes: {
                    root: classes.activeInputLabelColor,
                    focused: "focused",
                  },
                }}
                InputProps={{
                  classes: {
                    root: classes.activeInputColor,
                    input: classes.resize,
                    focused: "focused",
                  },
                  required: true,
                }}
                label="Fee Rate"
                error={validationError.feeRate}
                value={values.feeRate}
                onChange={(e) => {
                  setSubmitDisabled(false);
                  onChange(e.target.value, "feeRate");
                }}
                helperText={validationError.feeRate && "Fee Rate is required."}
                name="feeRate"
                id="feeRate"
              >
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Per Transaction"
                >
                  Per Transaction
                </MenuItem>
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Percentage"
                >
                  Percentage
                </MenuItem>
                <MenuItem
                  className={classes.dialogBoxDropDown}
                  value="Per transaction + Percentage"
                >
                  Per transaction + Percentage
                </MenuItem>
                <MenuItem className={classes.dialogBoxDropDown} value="None">
                  None
                </MenuItem>
              </TextField>
            </Grid>
            {values.feeRate === "Per Transaction" && (
              <Grid item lg={4} sm={6} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={isPageDisabled}
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Per Transaction Fee"
                  value={values.perTransactionFee}
                  name="perTransactionFee"
                  id="perTransactionFee"
                  type="number"
                  onChange={(e) =>
                    onChange(e.target.value, "perTransactionFee")
                  }
                  error={validationError.perTransactionFee}
                  helperText={
                    validationError.perTransactionFee && "Fee Rate is required."
                  }
                />
              </Grid>
            )}
            {values.feeRate === "Percentage" && (
              <Grid item lg={4} sm={6} xs={12}>
                <AccountBalanceIcon
                  className={classes.inputBox}
                  fontSize="small"
                />
                <TextField
                  disabled={isPageDisabled}
                  className={classes.root}
                  inputlabelprops={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      input: classes.resize,
                      focused: "focused",
                    },
                  }}
                  label="Percentage Fee"
                  value={values.percentageFee}
                  name="percentageFee"
                  id="percentageFee"
                  type="number"
                  onChange={(e) => onChange(e.target.value, "percentageFee")}
                  error={validationError.percentageFee}
                  helperText={
                    validationError.percentageFee && "Fee Rate is required."
                  }
                />
              </Grid>
            )}
            {values.feeRate === "Per transaction + Percentage" && (
              <>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Per tran fee</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={isPageDisabled}
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Per Transaction Fee"
                    value={values.perTransactionFee}
                    name="perTransactionFee"
                    id="perTransactionFee"
                    type="number"
                    onChange={(e) =>
                      onChange(e.target.value, "perTransactionFee")
                    }
                    error={validationError.perTransactionFee}
                    helperText={
                      validationError.perTransactionFee &&
                      "Fee Rate is required."
                    }
                  />
                </Grid>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Plus</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={isPageDisabled}
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Percentage Fee"
                    value={values.percentageFee}
                    name="percentageFee"
                    id="percentageFee"
                    type="number"
                    onChange={(e) => onChange(e.target.value, "percentageFee")}
                    error={validationError.percentageFee}
                    helperText={
                      validationError.percentageFee && "Fee Rate is required."
                    }
                  />
                  <div>
                    <Typography className={classes.feetype}>
                      <b>%</b>
                    </Typography>
                  </div>
                </Grid>
                <Grid item lg={4} sm={6} xs={12} style={{ display: "flex" }}>
                  <div>
                    <Typography className={classes.feetype}>
                      <b>Above</b>
                    </Typography>
                  </div>
                  <AccountBalanceIcon
                    className={classes.inputBox}
                    fontSize="small"
                  />
                  <TextField
                    disabled={isPageDisabled}
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLabelColor,
                        focused: "focused",
                      },
                    }}
                    InputProps={{
                      classes: {
                        root: classes.activeInputColor,
                        input: classes.resize,
                        focused: "focused",
                      },
                    }}
                    label="Transaction Value"
                    value={values.aboveTransactionValue}
                    name="aboveTransactionValue"
                    id="aboveTransactionValue"
                    type="text"
                    onChange={(e) =>
                      onChange(e.target.value, "aboveTransactionValue")
                    }
                    error={validationError.aboveTransactionValue}
                    helperText={
                      validationError.aboveTransactionValue &&
                      "Fee Rate is required."
                    }
                  />
                </Grid>
              </>
            )}
            {profileCode !==
              (profileCodePermissionCheck.profileCode.SA ||
                profileCodePermissionCheck.profileCode.ADM) && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: {
                      xl: "center",
                      lg: "center",
                      md: "flex-start",
                    },
                    alignItems: "center",
                    alignContent: "center",
                  }}
                  lg={12}
                  sm={6}
                  xs={3}
                >
                  <FormControl
                    className={classes.root}
                    inputlabelprops={{
                      classes: {
                        root: classes.activeInputLableColor,
                        focused: "focused",
                      },
                    }}
                    component="fieldset"
                  >
                    <FormGroup
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignContent: "center",
                        alignItems: "center",
                        flexWrap: "nowrap",
                      }}
                      row
                    >
                      <FormLabel
                        style={{ marginTop: "10px", fontSize: "14px" }}
                        component="span"
                      >
                        Fee cannot be edited by business
                      </FormLabel>
                      <FormControlLabel
                        style={{ marginTop: "10px", marginLeft: "10px" }}
                        disabled={isPageDisabled}
                        control={(
                          <Checkbox
                            color="primary"
                            checked={values.feeCanNotBeEdited}
                            disabled={
                              values.feeRate !== "Per Transaction" &&
                              values.feeRate !== "Percentage" &&
                              values.feeRate !== "Per transaction + Percentage" &&
                              values.feeRate !== "None"
                            }
                            onChange={(e) => {
                              setSubmitDisabled(false);
                              handleEditFeeCheckboxChange(e);
                            }}
                            name="feeCanNotBeEdited"
                          />
                        )}
                      />
                    </FormGroup>
                    <FormHelperText>{validationError.readOnly}</FormHelperText>
                  </FormControl>
                </Grid>
              )}
          </Grid>

        </>
      )}
      {achValue && (
        <>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography className={classes.tittleTextColor}>ACH </Typography>
          </Box>
          <Box
            style={{
              alignItems: "center",
              marginTop: "30px",
              backgroundColor: "#afafaf",
            }}
            className={classes.tittleColor}
            height={40}
          >
            <Typography
              style={{
                color: "black",
              }}
              className={classes.tittleTextColor}
            >
              Management Group Details
            </Typography>
          </Box>
          <Grid
            container
            className={classes.margin}
            style={{ textAlign: "center" }}
          >
            {merchantSetup !== "true" ? (
              <Grid
                container
                className={classes.margin}
                style={{ textAlign: "center" }}
              >
                <Grid
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                  item
                  lg={7}
                  sm={6}
                  xs={12}
                >
                  <Button
                    disabled={!achValue}
                    variant="contained"
                    className={classes.buttonStyle}
                    onClick={() => {
                      setAssignGroupsModal(true);
                      handleAssignAccounts(selectedEmail);
                    }}
                  >
                    Assign Merchant Accounts
                  </Button>
                </Grid>
                <Grid
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    justifyContent: "end",
                  }}
                  item
                  lg={5}
                  sm={6}
                  xs={12}
                >
                  <Typography
                    style={{
                      marginBottom: "10px",
                      fontWeight: "600",
                      paddingRight: "10px",
                    }}
                  >
                    Selected: {selectedRows?.length} / {tableData?.length}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid style={{ marginTop: "10px" }} item lg={12} sm={6} xs={12}>
                  <Button
                    variant="contained"
                    className={classes.buttonStyle}
                    onClick={() => {
                      // setSubmitDisabled(false);
                      setLoadingDialog(true);
                      handleAssignGroup();
                    }}
                  //  disabled={filedsDisabled}
                  >
                    Assign Merchant Group
                  </Button>
                </Grid>
                <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                    width: "100%",
                  }}
                >
                  {selectedRows.map((row, index) => (
                    <Chip
                      className={classes.chip}
                      key={index}
                      //    disabled={
                      //      values.Status_Code !== 1 && values.Status_Code !== ""
                      //    }
                      label={`${row.name}`}
                      onDelete={() => {
                        setSubmitDisabled(false);
                        handleDeleteChip(row);
                      }}
                      deleteIcon={<CloseIcon />}
                    />
                  ))}
                </Box>
              </>
            )}
            {merchantSetup === "true" && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                  {values.Balance_Check_Provider === "DecisionLogic" ? (
                    <Grid
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        paddingRight: "10px",
                      }}
                      item
                      lg={6}
                      sm={6}
                      xs={12}
                    >
                      <TextField
                        required={actionPermission(
                          permissionCheck.Category.setup,
                          permissionCheck.Page.merchant,
                          permissionCheck.option.asterisk
                        )}
                        style={{ width: "50%", marginTop: "10px" }}
                        inputlabelprops={{
                          classes: {
                            root: classes.activeInputLableColor,
                            focused: "focused",
                          },
                        }}
                        fullWidth
                        InputProps={{
                          classes: {
                            root: classes.activeInputColor,
                            input: classes.resize,
                            focused: "focused",
                          },
                        }}
                        //    disabled={
                        //      values.Status_Code !== 1 && values.Status_Code !== ""
                        //    }
                        label="Open Banking Solution Provider"
                        value={
                          Array.isArray(values.Balance_Check_Provider)
                            ? values.Balance_Check_Provider
                            : [values.Balance_Check_Provider]
                        }
                        error={validationError.balanceCheckProvider}
                        onChange={(e) => {
                          let newValue = e.target.value;

                          if (newValue.includes("None")) {
                            // If "None" is selected
                            if (
                              values.Balance_Check_Provider?.includes("None") &&
                              newValue.length > 1
                            ) {
                              // Case: "None" was selected, but now user picks something else → remove "None"
                              newValue = newValue.filter((val) => val !== "None");
                            } else {
                              // Case: User explicitly picked "None" → reset all, keep only "None"
                              newValue = ["None"];
                            }
                          } else {
                            // Case: Only other options, make sure "None" is never included
                            newValue = newValue.filter((val) => val !== "None");
                          }

                          setSubmitDisabled(false);
                          setBalanceCheckProvider(newValue);
                          onChange(newValue, "balanceCheckProvider");
                        }}
                        helperText={
                          validationError.balanceCheckProvider &&
                          "Balance Check State is required."
                        }
                        // disabled={isPageDisabled}
                        name="balanceCheckProvider"
                        id="balanceCheckProvider"
                        select
                        SelectProps={{
                          multiple: true,
                          renderValue: (selected) =>
                            Array.isArray(selected) ? selected.join(", ") : selected,
                        }}
                      >
                        {props.roles?.lookupMasterData?.data[0]?.LookUp_Detail
                          ?.slice() // create copy, don't mutate original array
                          .sort((a, b) => a.Sequence - b.Sequence)
                          .map((item) => (
                            <MenuItem
                              key={item._id}
                              className={classes.openClasses}
                              value={item.Lookup_Detail_Name}
                            >
                              <Checkbox
                                color="primary"
                                checked={
                                  values.Balance_Check_Provider?.indexOf(
                                    item.Lookup_Detail_Name
                                  ) > -1
                                }
                              />
                              <ListItemText
                                color="primary"
                                primary={item.Lookup_Detail_Name}
                              />
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  ) : (
                    <Grid item lg={12} sm={6} xs={12}>
                      <TextField
                        required={actionPermission(
                          permissionCheck.Category.setup,
                          permissionCheck.Page.merchant,
                          permissionCheck.option.asterisk
                        )}
                        fullWidth
                        style={{ width: "50%", marginTop: "10px" }}
                        inputlabelprops={{
                          classes: {
                            root: classes.activeInputLableColor,
                            focused: "focused",
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.activeInputColor,
                            input: classes.resize,
                            focused: "focused",
                          },
                        }}
                        //    disabled={
                        //      values.Status_Code !== 1 && values.Status_Code !== ""
                        //    }
                        label="Open Banking Solution Provider"
                        // disabled={isPageDisabled}
                        value={
                          Array.isArray(values.Balance_Check_Provider)
                            ? values.Balance_Check_Provider
                            : [values.Balance_Check_Provider]
                        }
                        error={validationError.balanceCheckProvider}
                        onChange={(e) => {
                          let newValue = e.target.value;

                          if (newValue.includes("None")) {
                            // If "None" is selected
                            if (
                              values.Balance_Check_Provider?.includes("None") &&
                              newValue.length > 1
                            ) {
                              //  Case: "None" was selected, but now user picks something else → remove "None"
                              newValue = newValue.filter((val) => val !== "None");
                            } else {
                              //  Case: User explicitly picked "None" → reset all, keep only "None"
                              newValue = ["None"];
                            }
                          } else {
                            //  Case: Only other options, make sure "None" is never included
                            newValue = newValue.filter((val) => val !== "None");
                          }

                          setSubmitDisabled(false);
                          setBalanceCheckProvider(newValue);
                          onChange(newValue, "balanceCheckProvider");
                        }}
                        helperText={
                          validationError.balanceCheckProvider &&
                          "Balance Check State is required."
                        }
                        name="balanceCheckProvider"
                        id="balanceCheckProvider"
                        select
                        SelectProps={{
                          multiple: true,
                          renderValue: (selected) =>
                            Array.isArray(selected) ? selected.join(", ") : selected,
                        }}
                      >
                        {props.roles?.lookupMasterData?.data[0]?.LookUp_Detail
                          ?.slice() // create copy, don't mutate original array
                          .sort((a, b) => a.Sequence - b.Sequence)
                          .map((item) => (
                            <MenuItem
                              key={item._id}
                              className={classes.openClasses}
                              value={item.Lookup_Detail_Name}
                            >
                              <Checkbox
                                color="primary"
                                checked={
                                  values.Balance_Check_Provider?.indexOf(
                                    item.Lookup_Detail_Name
                                  ) > -1
                                }
                              />
                              <ListItemText
                                color="primary"
                                primary={item.Lookup_Detail_Name}
                              />
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  )}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                  {serviceKeyVisible === true ||
                    (values?.Balance_Check_Provider &&
                      values.Balance_Check_Provider.includes("DecisionLogic Service") &&
                      values?.serviceKey !== "") ? (
                    <Grid
                      item
                      lg={12}
                      sm={12}
                      xs={12}
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <TextField
                        className={classes.root}
                        inputlabelprops={{
                          classes: {
                            root: classes.activeInputLabelColor,
                            focused: "focused",
                          },
                        }}
                        InputProps={{
                          classes: {
                            root: classes.activeInputColor,
                            input: classes.resize,
                            focused: "focused",
                          },
                        }}
                        //    disabled={
                        //      values.Status_Code !== 1 && values.Status_Code !== ""
                        //    }
                        required
                        style={{ width: "50%", marginTop: "10px" }}
                        label="Service key for Decision Logic"
                        value={values.serviceKey}
                        name="Service key for Decision Logic"
                        id="serviceKey"
                        type="text"
                        // disabled={isPageDisabled}
                        onChange={(e) => {
                          setSubmitDisabled(false);
                          onChange(e.target.value, "serviceKey");
                        }}
                        error={validationError.serviceKey}
                        helperText={
                          validationError.serviceKey && "Service Key is required."
                        }
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}

          </Grid>
        </>
      )}
      <Divider style={{ marginTop: "20px", marginBottom: "10px" }} />
      <Grid
        container
        style={{ justifyContent: "center", margin: "20px 0" }}
        className={classes.margin}
      >
        <Grid
          container
          spacing={2}
          style={{
            textAlign: "center",
            marginTop: "10px",
            justifyContent: "inherit",
            flexWrap: smallDevice ? "wrap" : "nowrap",
          }}
        >
          <Button
            variant="contained"
            className={classes.buttonStyle}
            onClick={handleBack}
          >
            Back
          </Button>
          {values.Status_Code == 3 || profileCode === profileCodePermissionCheck.profileCode.VCS || profileCode === profileCodePermissionCheck.profileCode.SA ? (
            <>
              <Button
                variant="contained"
                className={classes.buttonStyle}
                id="saveDraftBusinessForm"
                onClick={() => {
                  setUpdateConfirmationMessage(getUpdateConfirmationMessage());
                  setUpdateConfirmDialog(true);
                }}
                disabled={
                  accountAccessibility.length === 0 ||
                  submitDisabled ||
                  (achValue && selectedRows.length === 0)
                }
              >
                Update
              </Button>
            </>
          ) : ""}
        </Grid>
      </Grid>
    </div>
  );
}

EditServices.propTypes = {
  disabled: PropTypes.bool,
  validationError: PropTypes.object,
  index: PropTypes.any,
  data: PropTypes.object,
  add: PropTypes.func,
  remove: PropTypes.func,
  kycCheckListFlag: PropTypes.bool,
  createPermissionFlag: PropTypes.bool,
  editPermissionFlag: PropTypes.bool,
  formData: PropTypes.object,
  getCountryTypeList: PropTypes.func,
  mainData: PropTypes.object,
  history: PropTypes.object,
  roles: PropTypes.object,
  app: PropTypes.object,
  sendInviteApiCall: PropTypes.func,
  getMerchantListData: PropTypes.func,
  getManagerListDataNames: PropTypes.func,
  getMerchantGroupCode: PropTypes.func,
  getMerchantGroupCodePortfolios: PropTypes.func,
  getRtpAch: PropTypes.func,
  submitApiCall: PropTypes.func,
  submitBSApiCall: PropTypes.func,
  getRoutingNumberData: PropTypes.func,
  emptyMerchantRTNReduxState: PropTypes.func,
  getAccountNumberData: PropTypes.func,
  emptyMerchantAccReduxState: PropTypes.func,
  getEmailList: PropTypes.func,
  getEmailData: PropTypes.func,
  emptyEmailListReduxState: PropTypes.func,
};

const mapStateToProps = (app) => ({
  formData: app.provideRegistration,
  mainData: app,
  roles: app.roles,
  app: app.app,
  signUpData: app,
  merchantListData: app.merchantInformation,
  marchantGroupCodeList: app.merchantInformation.marchantGroupCodeList,
  achRtpList: app.merchantInformation.achRtpList,
  routingNumberData: app.merchantInformation.routingNumberData,
  accountNumberData: app.merchantInformation.accountNumberData,
});

export default connect(mapStateToProps, {
  getCountryTypeList,
  sendInviteApiCall,
  getMerchantListData,
  getManagerListDataNames,
  getMerchantGroupCode,
  getMerchantGroupCodePortfolios,
  getRtpAch,
  submitApiCall,
  submitBSApiCall,
  getRoutingNumberData,
  emptyMerchantRTNReduxState,
  getAccountNumberData,
  emptyMerchantAccReduxState,
  emptyEmailListReduxState,
  getEmailList,
  getEmailData,
})(EditServices);